import React  from 'react'

// import {CorePalette} from "../../../../../color-coding/color-coding"
import FieldRAG_Icon from "../../../../generic/rag/components/rag-icon"

const debug = false
// const debug = "FieldGoalHealth_GoalListView"

export default function FieldGoalHealth_GoalListView(props:any) {

    const value = _.get(props.model, props.field.fieldId, null)
    const option = props.field._getOption(value)

    debug && console.log(debug, 'render', value, option, props)

    if (!option) return false

    return (
        <div className={Classes("ui5-txt-default fl-ac txt-truncate", props.className)}>
            <FieldRAG_Icon className    = "flex-row-center-center"
                           option       = {option}/>
        </div>
    )
}
